/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Wizard_Toast_Sync_ErrorInputs */



/**
* | output |
* | --- |
* | "Space created but sync failed. You can sync manually." |
*
* @param {Spaces_Wizard_Toast_Sync_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_toast_sync_error = /** @type {((inputs?: Spaces_Wizard_Toast_Sync_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Toast_Sync_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Space wurde erstellt, aber die Synchronisierung ist fehlgeschlagen. Du kannst manuell synchronisieren.")
	return /** @type {LocalizedString} */ ("Space created but sync failed. You can sync manually.")
});